.nav {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}

.button {
  align-items: center;
  border-radius: 12px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  height: 32px;
  justify-content: center;
  transition: background-color 0.15s, border-color 0.15s;
  width: 32px;

  &.isActive {
    background: var(--color-secondary);
    border: 1px solid var(--color-border);
    color: var(--color-foreground);
  }

  &:not(.isActive) {
    background: var(--color-background);
    border: 1px solid var(--color-border);
    color: var(--color-foreground);

    &:hover {
      border-color: var(--color-foreground);
    }
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
}
